export default {
  HAT: "HAT",
  GLASSES: "GLASSES",
  JEWELLERY: "JEWELLERY",
  GOGGLES: "GOGGLES",
  EARRINGS: "EARRINGS",
  NECKLACE: "NECKLACE",
};
